module.exports = __webpack_public_path__ + "static/media/search.c9dff686.svg";